import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { L10N_LOCALE } from 'angular-l10n';
import { FileModel } from 'src/app/hickory-api';
import { AuthService } from 'src/app/shared/authentication/auth.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilesViewContext } from '../file-view-context';
import { FilesDataSource } from '../files-datasource';

@Component({
  selector: 'app-files-search-and-sort',
  imports: [SharedModule],
  templateUrl: './files-search-and-sort.component.html',
  styleUrl: './files-search-and-sort.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilesSearchAndSortComponent {
  private readonly auth = inject(AuthService);
  protected get isSuperAdmin() { return this.auth.isSuperAdmin(); }

  public readonly locale = inject(L10N_LOCALE);
  public readonly viewContext = input.required<FilesViewContext>();
  public readonly datasource = input.required<FilesDataSource>();
  public readonly fileSearch = input.required<FormControl>();
  public readonly showSortOptions = input<boolean>(true);
  
  protected get sortOptions() {
    return this.datasource()?.sortableFields.map((field, id) => ({
      id,
      value: field as keyof FileModel,
      label: `Files.Table.${field}`
    }));
  }
  
  protected get searchSuffixBtn() {
    return this.viewContext().getSearchSuffix(this.fileSearch());
  }
  
  protected get sortDirectionInfo() {
    return {
      icon: this.viewContext().sortDirection() === 'asc' ? 'arrow_upward' : 'arrow_downward',
      label: this.viewContext().sortDirection() === 'asc' ? 'Files.Shared.SortAsc' : 'Files.Shared.SortDesc',
      value: (this.viewContext().sortDirection() === 'asc' ? 'desc' : 'asc') as 'asc' | 'desc'
    }
  }
  
  protected handleKeypressForSearch(event: KeyboardEvent) {
    if (!this.searchSuffixBtn.disabled && event.key === 'Enter') {
      this.searchSuffixBtn.action();
    }
  }

  protected handleSortChange(field: keyof FileModel, direction: 'asc' | 'desc') {
    this.viewContext().update({ sortField: field, sortDirection: direction });
    this.datasource().sortWithoutLoad(field, direction);
  }

  protected sortByFieldText() {
    return `Files.Table.${this.viewContext().sortField()}`;
  }
}
